/*@flow*/
import { active as d3Active } from 'd3-transition';
import { interpolateNumber } from 'd3-interpolate';
import { format as d3Format } from 'd3-format';
import { select as d3Select } from 'd3-selection';

export default (el: Element, value: number) => {
  const format = d3Format(',d');

  const onTweenText = function() {
    const that = d3Select(this);
    const newVal = parseInt(that.text().replace(/,/g, ''), 10);
    const i = interpolateNumber(newVal, value);

    return t => {
      let v = i(t);

      // HACK: I don't know why this keeps happening. Need
      // to investigate further.
      if (isNaN(v)) {
        v = t;
      }

      return that.text(format(v));
    };
  };

  const onStart = () => {
    d3Active(el)
      .tween('text', onTweenText)
      .transition()
      .delay(1500);
  };

  d3Select(el)
    .transition()
    .duration(800)
    .on('start', onStart);
};
